export const environment = {
    production: true,
    default_user: null,
    apiUrl: "https://airiobravowms.com",
    printerIP: "172.16.7.47"
};
